export default __webpack_public_path__ + "static/media/carrot-down.993afb75.svg";